'use strict';

module.exports = /*@ngInject*/
{
    pagination: {
        /**
         * A pagination link is clicked
         * @publishers PaginationDirective
         */
        click: 'pagination:click',

        /**
         * The pagination directive is loaded
         * @publishers PaginationDirective
         */
        load: 'pagination:load',

        /**
         * Next page of pagination is clicked
         * @publishers PaginationDirective
         */
        next: 'pagination:next',

        /**
         * Previous page of pagination is clicked
         * @publishers PaginationDirective
         */
        previous: 'pagination:previous'
    },

    user: {
        /**
         * User log out event
         * @subscribers ProfileService
         * @publishers ProfileHTTPService
         */
        logout: 'user:logout'
    }
};
